module.exports = __webpack_public_path__ + "static/media/btnTripAdvisor.a20e67ab.png";